// Listen for change event on color swatch inputs
const colorInputs = document.querySelectorAll(".variant__input--color-swatch");
const colorDisplay = document.getElementById("selectedColor");

colorInputs.forEach((input) => {
  input.addEventListener("change", function () {
    const selectedColor = this.getAttribute("data-color-name");
    colorDisplay.textContent = selectedColor;
  });

  // Check if the color input is selected by default and if so, display its color name
  if (input.checked) {
    const defaultColor = input.getAttribute("data-color-name");
    colorDisplay.textContent = defaultColor;
  }
});


// Trigger change event on default selected color swatch input
const defaultSelectedInput = document.querySelector('input.variant__input--color-swatch:checked');
if (defaultSelectedInput) {
  defaultSelectedInput.dispatchEvent(new Event('change'));
}
